import React from "react";
import { Edit2, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEditMode } from "../../context/EditModeContext";

export const EditModeToggle = ({ pageId }) => {
  const navigate = useNavigate();
  const { isEditMode, setIsEditMode, setEditingPageId } = useEditMode();

  // Check if in inline edit mode (from Page Editor dashboard selection)
  const isInlineEditMode = sessionStorage.getItem("editMode") === "true";

  if (!isInlineEditMode) return null;

  const handleExitEditMode = () => {
    // Clear edit mode session
    sessionStorage.removeItem("editMode");
    sessionStorage.removeItem("editModeUser");
    setEditingPageId(null);
    setIsEditMode(false);
    // Navigate back to admin panel
    navigate("/admin");
  };

  const handleToggleEditMode = () => {
    if (!isEditMode) {
      setEditingPageId(pageId);
    } else {
      setEditingPageId(null);
    }
    setIsEditMode(!isEditMode);
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-3">
      <button
        onClick={handleToggleEditMode}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition ${
          isEditMode
            ? "bg-amber-600 hover:bg-amber-700 text-white"
            : "bg-blue-600 hover:bg-blue-700 text-white"
        }`}
      >
        {isEditMode ? (
          <>
            <X size={18} />
            Done Editing
          </>
        ) : (
          <>
            <Edit2 size={18} />
            Edit Page
          </>
        )}
      </button>

      <button
        onClick={handleExitEditMode}
        className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium bg-gray-600 hover:bg-gray-700 text-white transition"
      >
        <X size={18} />
        Exit Edit Mode
      </button>
    </div>
  );
};
